<template lang="pug">
  .content-wrapper
    section
      .container
        .task-list__header
          h1.ui-title-1 Список квартир

          // Filter
          // .buttons-list
            .button.button--round.button-default(
              @click="filter = 'active'"
            ) Не сданные квартиры
            .button.button--round.button-default(
              @click="filter = 'completed'"
            ) Сданные квартиры
            .button.button--round.button-default(
              @click="filter = 'all'"
            ) Все квартиры

        // Tasl load
        .task-list
          transition-group(name="taskList")
            .task-item(
              v-for="task in tasksFilter"
              :key="task.id"
              :class="{ completed: task.completed }"
            )
              .ui-card.ui-card--shadow
                .task-item__info
                  .task-item__main-info
                    span.ui-label(
                      :class="[{ 'ui-label--primary': !task.completed }, { 'ui-label--light': task.completed  }]"
                    ) {{ task.time }}
                    // span Адрес:
                    // span {{ task.time }}
                  // span.button-close(
                    @click="deleteTask1(task.id)"
                  // )
                  //span.ui-label(
                    :class="[{ 'ui-label--primary': !task.completed }, { 'ui-label--primary': task.completed  }]"
                  //)
                    span статус: квартира
                    span(v-if="task.completed")  закрыта
                    span(v-else)  открыта
                .task-item__content
                  span.ui-label(
                    :class="[{ 'ui-label--primary': !task.completed }, { 'ui-label--primary': task.completed  }]"
                  )
                    span статус: квартира
                    span(v-if="task.completed")  закрыта
                    span(v-else)  открыта
                span.ui-title-5 {{'Номер оборудования: ' + task.boxNumber}}
                  .task-item__header
                    // .ui-checkbox-wrapper
                      input.ui-checkbox(
                        type="checkbox"
                        v-model="task.completed"
                        @click="taskCompleted(task.id, task.completed)"
                      )
                    span.ui-title-2 {{'Код доступа Гостя '+ task.idHome + ''}}
                    .button.button--round.button-light(
                      @click="taskEdit2(task.id, task.title, task.description, task.timeStart, task.timeStart2, task.idHome, task.time, task.opisaniye, task.datePickerStart, task.timePickerStart, task.datePickerEnd, task.timePickerEnd, task.startDate, task.endDate)"
                    ) СМС
                  .task-item__body
                    span.ui-title-4 {{'Предоставлен доступ: С ' + task.startDate + ' ▬' + ' До ' + task.endDate}}
                    // span.ui-title-2 {{'Код доступа Клининга '+ task.boxNumber + ''}}
                    // p.ui-text-regular {{ task.description }}
                  .task-item__foter

                    // Tags load
                    .tag-list
                      .ui-tag__wrapper(
                        v-for="tag in task.tags"
                        :key="tag.title"
                      )
                        .ui-tag
                          span.tag-title {{ tag.title }}

                      // Buttons
                      .buttons-list
                        // тестовая дополнительная кнопка
                        // .button.button--round.button-default(
                        //  @click="openHomeWithId(task.id)"
                        // ) Сдать в а.button.button--roundренду
                        .button.button--round(
                          @click="taskCompleted(task.id, task.user, task.completed, task.time, task.boxNumber)"
                          :class="[{ 'button-primary': !task.completed }, { 'button-light': task.completed  }]"
                        )
                          span(v-if="task.completed") Открыть квартиру
                          span(v-else) Закрыть квартиру
                        //.button.button--round.button-default(
                          @click="openHome(task.id)"
                        //) Открыть квартиру
                        //.button.button--round.button-default(
                          @click="closeHome(task.id)"
                        //) Закрыть квартиру
                        .button.button--round.button-primary(
                          @click="taskEdit(task.id, task.title, task.description, task.timeStart, task.timeStart2, task.idHome, task.time, task.opisaniye, task.datePickerStart, task.timePickerStart, task.datePickerEnd, task.timePickerEnd, task.user, task.boxNumber)"
                        ) Новое заселение
                        .button.button--round.button-primary(
                          @click="taskEdit1(task.id, task.description, task.time, task.opisaniye, task.datePickerEnd, task.timePickerEnd, task.endDate)"
                        ) Продлить заселение
                        .button.button--round.button-primary(
                          @click="taskEdit3(task.id, task.description, task.time, task.opisaniye, task.datePickerEnd, task.timePickerEnd)"
                        ) Изменить описание
                        .button.button--round.button-light(
                          @click="stopDostup(task.id, task.title, task.description, task.timeStart, task.timeStart2, task.idHome)"
                        ) Закончить доступ
                        //.button.button--round(
                          @click="taskCompleted(task.id, task.completed)"
                          :class="[{ 'button-primary': !task.completed }, { 'button-light': task.completed  }]"
                        //)
                          span(v-if="task.completed") Свободна
                          span(v-else) Занята

    // Edit popup
    .ui-messageBox__wrapper(
      v-if="editingPopup"
      @click="cancelTaskEdit"
      :class="{active: editingPopup}"
    )
      .ui-messageBox.fadeInDown(
        @click.stop=""
      )
        .ui-messageBox__header
          // span.messageBox-title {{ titleEditing }}
          span.button-close(@click="cancelTaskEdit")
        .ui-messageBox__content
          p Дата начала доступа:
          date-picker(
            v-model='datePickerStart'
            locale='en'
            format='DD.MM.YYYY'
            :auto-submit='true'
            placeholder='Выберите дату начала'
          )
          p Время начала доступа:
          date-picker(
            v-model='timePickerStart'
            type='time'
            initial-value='14:00'
            locale='en'
            placeholder='Выберите время начала'
            :jumpMinute='15'
            :roundMinute='true'
          )
          p Дата окончания доступа:
          date-picker(
            v-model='datePickerEnd'
            locale='en'
            format='DD.MM.YYYY'
            :auto-submit='true'
            placeholder='Выберите дату окончания'
          )
          p Время окончания доступа:
          date-picker(
            v-model='timePickerEnd'
            type='time'
            initial-value='12:00'
            locale='en'
            placeholder='Выберите время окончания'
            :jumpMinute='15'
            :roundMinute='true'
          )
          // input(
            type="text"
            maxlength="10"
            placeholder="ДД.ММ.ГГГГ"
            v-model='titleEditing'
            @keyup.esc="cancelTaskEdit"
          // )
          // date-picker(
            v-model='datePickerStart'
            lang='ru'
            type='text'
            format='DD.MM.YYYY'
            width ='500'
          // )
          // p Время начала доступа:
          //input(
            type="text"
            maxlength="5"
            placeholder="00:00"
            v-model='timeStart'
            @keyup.esc="cancelTaskEdit"
          //)
          // date-picker(
            v-model='timePickerStart'
            lang='ru'
            type='time'
            format='HH:mm'
            placeholder='Выберите время'
            :minute-step='5'
            width ='500'
            confirm
          // )
          // p Дата окончания доступа:
          //input(
            type="text"
            maxlength="10"
            placeholder="ДД.ММ.ГГГГ"
            v-model='desrEditing'
            @keyup.esc="cancelTaskEdit"
          //)
          // date-pick(
            v-model='datePickerEnd'
            :format="'DD.MM.YYYY'"
          // )
          //date-picker(
            v-model='datePickerEnd'
            lang='ru'
            type='text'
            format='DD.MM.YYYY'
            width ='500'
          //)
          // p Время окончания доступа:
          //input(
            type="text"
            maxlength="5"
            placeholder="00:00"
            v-model='timeStart2'
            @keyup.esc="cancelTaskEdit"
          //)
          // date-picker(
            v-model='timePickerEnd'
            lang='ru'
            type='time'
            format='HH:mm'
            placeholder='Выберите время'
            :minute-step='5'
            width ='500'
            confirm
          // )
          //p Код доступа уборщицы:
          //input(
            type="text"
            maxlength="6"
            placeholder="Код доступа уборщицы"
            v-model='idСleaning'
            @keyup.esc="cancelTaskEdit"
          //)
          p Адрес:
          input(
            type="text"
            maxlength="100"
            placeholder="Адрес"
            v-model='time'
            @keyup.esc="cancelTaskEdit"
          )
          p Описание квартиры:
          input(
            type="text"
            maxlength="300"
            placeholder="Описание квартиры (300 символов)"
            v-model='opisaniye'
            @keyup.esc="cancelTaskEdit"
          )
          // p Тест для ключа Время окончания доступа:
          // input(
            type="text"
            v-model='idHome'
            @keyup.esc="cancelTaskEdit"
          //)
        .ui-messageBox__footer
          .button.button-light(@click="cancelTaskEdit") Отмена
          .button.button-primary(@click="finishTaskEdit") Подтвердить
    .ui-messageBox__wrapper(
      v-if="editingPopup1"
      @click="cancelTaskEdit1"
      :class="{active: editingPopup1}"
    )
      .ui-messageBox.fadeInDown(
        @click.stop=""
      )
        .ui-messageBox__header
          span.messageBox-title {{ 'Здесь вы можете продлить доступ. При этом код доступа не измениться' }}
          // span.messageBox-title {{ titleEditing }}
          span.button-close(@click="cancelTaskEdit1")
        .ui-messageBox__content
          p Дата окончания доступа:
          date-picker(
            v-model='datePickerEnd'
            locale='en'
            format='DD.MM.YYYY'
            :auto-submit='true'
            placeholder='Выберите дату окончания'
          )
          p Время окончания доступа:
          date-picker(
            v-model='timePickerEnd'
            type='time'
            initial-value='12:00'
            locale='en'
            placeholder='Выберите время окончания'
            :jumpMinute='15'
            :roundMinute='true'
          )
          p Адрес:
          input(
            type="text"
            maxlength="100"
            placeholder="Адрес"
            v-model='time'
            @keyup.esc="cancelTaskEdit"
          )
          p Описание квартиры:
          input(
            type="text"
            maxlength="300"
            placeholder="Описание квартиры (300 символов)"
            v-model='opisaniye'
            @keyup.esc="cancelTaskEdit"
          )
        .ui-messageBox__footer
          .button.button-primary(@click="finishTaskEdit1") Готово
    .ui-messageBox__wrapper(
      v-if="editingPopup2"
      @click="cancelTaskEdit2"
      :class="{active: editingPopup2}"
    )
      .ui-messageBox.fadeInDown(
        @click.stop=""
      )
        .ui-messageBox__header
          span.messageBox-title {{ 'Текст для СМС' }}
          span.button-close(@click="cancelTaskEdit2")
        .ui-messageBox__content
          p Здесь вы можете скопировать готовы текст для Гостя
          textarea(
            type="text"
            v-model='smsText'
          )
        .ui-messageBox__footer
          // .button.button-light(@click="cancelTaskEdit2") Отмена
          .button.button-primary(@click="finishTaskEdit2") Закрыть
    .ui-messageBox__wrapper(
      v-if="editingPopup3"
      @click="cancelTaskEdit3"
      :class="{active: editingPopup3}"
    )
      .ui-messageBox.fadeInDown(
        @click.stop=""
      )
        .ui-messageBox__header
          span.messageBox-title {{ 'Здесь вы можете изменить описание' }}
          // span.messageBox-title {{ titleEditing }}
          span.button-close(@click="cancelTaskEdit3")
        .ui-messageBox__content
          p Адрес:
          input(
            type="text"
            maxlength="100"
            placeholder="Адрес"
            v-model='time'
            @keyup.esc="cancelTaskEdit"
          )
          p Описание квартиры:
          input(
            type="text"
            maxlength="300"
            placeholder="Описание квартиры (300 символов)"
            v-model='opisaniye'
            @keyup.esc="cancelTaskEdit"
          )
        .ui-messageBox__footer
          .button.button-primary(@click="finishTaskEdit3") Сохранить
    .ui-messageBox__wrapper(
      v-if="editingPopup2"
      @click="cancelTaskEdit2"
      :class="{active: editingPopup2}"
    )
      .ui-messageBox.fadeInDown(
        @click.stop=""
      )
        .ui-messageBox__header
          span.messageBox-title {{ 'Текст для СМС' }}
          span.button-close(@click="cancelTaskEdit2")
        .ui-messageBox__content
          p Здесь вы можете скопировать готовы текст для Гостя
          textarea(
            type="text"
            v-model='smsText'
          )
        .ui-messageBox__footer
          // .button.button-light(@click="cancelTaskEdit2") Отмена
          .button.button-primary(@click="finishTaskEdit2") Закрыть
</template>

<script>
import DatePicker from 'vue2-datepicker'

import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
  components: {
    DatePick,
    DatePicker,
    datePicker: VuePersianDatetimePicker
  },
  data () {
    return {
      date: '',
      // если не будет работать заменить all на active
      filter: 'all',
      // Editing
      editingPopup3: false,
      editingPopup2: false,
      editingPopup1: false,
      editingPopup: false,
      titleEditing: '',
      desrEditing: '',
      timeStart: '',
      timeStart2: '',
      idHome: '',
      taskId: null,
      time: '',
      opisaniye: '',
      datePickerStart: '',
      timePickerStart: '',
      datePickerEnd: '',
      timePickerEnd: '',
      boxNumber: ''
    }
  },
  methods: {
    // Completed
    taskCompleted (id, user, completed, time, boxNumber) {
      completed ? completed = false : completed = true

      this.$store.dispatch('completedTask', {
        id,
        user,
        completed,
        time,
        boxNumber
      })
        .then(() => {
          console.log(completed)
          // this.$store.dispatch('loadTasks')
        })
      if (completed === false) {
        let message = {
          context: 'success',
          title: 'Квартира открыта'
        }
        this.$store.dispatch('getMessage', message)
      }
      if (completed === true) {
        let message = {
          context: 'success',
          title: 'Квартира закрыта'
        }
        this.$store.dispatch('getMessage', message)
      }
    },
    // Edit
    taskEdit (id, title, description, timeStart, timeStart2, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd, user, boxNumber) {
      this.editingPopup = !this.editingPopup
      // console.log({id, title, description})
      this.taskId = id
      this.titleEditing = title
      this.desrEditing = description
      this.timeStart = timeStart
      this.timeStart2 = timeStart2
      this.idHome = idHome
      this.time = time
      this.opisaniye = opisaniye
      this.datePickerStart = ''
      this.timePickerStart = ''
      this.datePickerEnd = ''
      this.timePickerEnd = ''
      this.user = user
      this.boxNumber = boxNumber
    },

    taskEdit1 (id, description, time, opisaniye, datePickerEnd, timePickerEnd) {
      this.editingPopup1 = !this.editingPopup1
      // console.log({id, title, description})
      this.taskId = id
      this.time = time
      this.opisaniye = opisaniye
      this.datePickerEnd = ''
      this.timePickerEnd = ''
    },
    taskEdit2 (id, title, description, timeStart, timeStart2, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd, startDate, endDate) {
      this.editingPopup2 = !this.editingPopup2
      // console.log({id, title, description})
      this.taskId = id
      this.titleEditing = title
      this.desrEditing = description
      this.timeStart = timeStart
      this.timeStart2 = timeStart2
      this.idHome = idHome
      this.time = time
      this.opisaniye = opisaniye
      this.datePickerStart = ''
      this.timePickerStart = ''
      this.datePickerEnd = ''
      this.timePickerEnd = ''
      this.smsText = 'Для открытия двери введите код ' + '"' + idHome + '"' + ' в приложении Quarta. Вам предоставлен доступ c ' + startDate + ' ▬' + ' до ' + endDate + '. Адрес квартиры: ' + time + '. Описание: ' + opisaniye + '. Скачать приложение Quarta для iOS - https://vk.cc/9qpov1 Скачать приложение Quarta для Android - https://vk.cc/9qppFF'
    },
    taskEdit3 (id, description, time, opisaniye, datePickerEnd, timePickerEnd) {
      this.editingPopup3 = !this.editingPopup3
      // console.log({id, title, description})
      this.taskId = id
      this.time = time
      this.opisaniye = opisaniye
    },

    // Cancel button (POPUP)
    cancelTaskEdit () {
      this.editingPopup = !this.editingPopup

      // Reset
      this.taskId = null
      this.titleEditing = ''
      this.desrEditing = ''
      this.timeStart = ''
      this.timeStart2 = ''
      this.idHome = ''
      this.time = ''
      this.opisaniye = ''
      this.datePickerStart = ''
      this.timePickerStart = ''
      this.datePickerEnd = ''
      this.timePickerEnd = ''
      this.user = null
      this.boxNumber = null
    },
    cancelTaskEdit1 () {
      this.editingPopup1 = !this.editingPopup1
      // Reset
      this.taskId = null
      this.time = ''
      this.opisaniye = ''
      this.datePickerEnd = ''
      this.timePickerEnd = ''
    },
    cancelTaskEdit2 () {
      this.editingPopup2 = !this.editingPopup2

      // Reset
      this.taskId = null
      this.titleEditing = ''
      this.desrEditing = ''
      this.timeStart = ''
      this.timeStart2 = ''
      this.idHome = ''
      this.time = ''
      this.opisaniye = ''
      this.datePickerStart = ''
      this.timePickerStart = ''
      this.datePickerEnd = ''
      this.timePickerEnd = ''
    },
    cancelTaskEdit3 () {
      this.editingPopup3 = !this.editingPopup3
      // Reset
      this.taskId = null
      this.time = ''
      this.opisaniye = ''
    },
    // Done button
    finishTaskEdit () {
      if (this.desrEditing === '' || this.time === '' || this.datePickerEnd === '' || this.timePickerEnd === '' || this.opisaniye === '' || this.titleEditing === '') {
        let message = {
          context: 'success',
          title: 'Пожалуйста заполните все поля'
        }
        this.$store.dispatch('getMessage', message)
      } else {
        this.$store.dispatch('editTask', {
          id: this.taskId,
          title: this.titleEditing,
          description: this.desrEditing,
          timeStart: this.timeStart,
          timeStart2: this.timeStart2,
          idHome: this.idHome,
          time: this.time,
          opisaniye: this.opisaniye,
          datePickerStart: this.datePickerStart,
          timePickerStart: this.timePickerStart,
          datePickerEnd: this.datePickerEnd,
          timePickerEnd: this.timePickerEnd,
          user: this.user,
          boxNumber: this.boxNumber
        })
        let message = {
          context: 'success',
          title: 'Изменения успешно сохранены'
        }
        this.$store.dispatch('getMessage', message)
        this.editingPopup = !this.editingPopup
      }
      // console.log(this.titleEditing)
    },
    finishTaskEdit1 () {
      if (this.opisaniye === '' || this.time === '' || this.datePickerEnd === '' || this.timePickerEnd === '') {
        let message = {
          context: 'success',
          title: 'Пожалуйста заполните все поля'
        }
        this.$store.dispatch('getMessage', message)
      } else {
      // console.log(this.titleEditing)
        this.$store.dispatch('editTask1', {
          id: this.taskId,
          description: this.desrEditing,
          time: this.time,
          opisaniye: this.opisaniye,
          datePickerEnd: this.datePickerEnd,
          timePickerEnd: this.timePickerEnd
        })
        let message = {
          context: 'success',
          title: 'Изменения успешно сохранены'
        }
        this.$store.dispatch('getMessage', message)
        this.editingPopup1 = !this.editingPopup1
      }
    },
    finishTaskEdit2 () {
      // console.log(this.titleEditing)
      this.editingPopup2 = !this.editingPopup2
    },
    finishTaskEdit3 () {
      if (this.opisaniye === '' || this.time === '') {
        let message = {
          context: 'success',
          title: 'Пожалуйста заполните все поля'
        }
        this.$store.dispatch('getMessage', message)
      } else {
        // console.log(this.titleEditing)
        this.$store.dispatch('editTask3', {
          id: this.taskId,
          time: this.time,
          opisaniye: this.opisaniye
        })
        let message = {
          context: 'success',
          title: 'Изменения успешно сохранены'
        }
        this.$store.dispatch('getMessage', message)
        this.editingPopup3 = !this.editingPopup3
      }
    },
    // Delete button
    deleteTask (id) {
      this.$store.dispatch('deleteTask', id)
        .then(() => {
          console.log('task deleted')
          this.$store.dispatch('loadTasks')
        })
    },
    openHome (id) {
      this.$store.dispatch('openHome', id)
        .then(() => {
          let message = {
            context: 'success',
            title: 'Открыто'
          }
          this.$store.dispatch('getMessage', message)
          console.log('task deleted')
          this.$store.dispatch('loadTasks')
        })
    },
    closeHome (id) {
      this.$store.dispatch('closeHome', id)
        .then(() => {
          let message = {
            context: 'success',
            title: 'Закрыто'
          }
          this.$store.dispatch('getMessage', message)
          console.log('task deleted')
          this.$store.dispatch('loadTasks')
        })
    },
    stopDostup (id, title, description, timeStart, timeStart2, idHome) {
      this.$store.dispatch('stopDostup', {id, title, description, timeStart, timeStart2, idHome})
        .then(() => {
          console.log('task stopDostup')
          this.$store.dispatch('loadTasks')
        })
    },
    openHomeWithId (id) {
      this.$store.dispatch('openHomeWithId', id)
        .then(() => {
          console.log('task deleted')
          this.$store.dispatch('loadTasks')
        })
    },

    // Delete button1 test
    deleteTask1 (id) {
      this.$store.dispatch('deleteTask', id)
        .then(() => {
          console.log('task1 deleted1')
          this.$store.dispatch('loadTasks')
        })
    }
  },
  computed: {
    // Filter buttons
    tasksFilter () {
      if (this.filter === 'active') {
        return this.$store.getters.taskNotCompleted
      } else if (this.filter === 'completed') {
        return this.$store.getters.taskCompleted
      } else if (this.filter === 'all') {
        return this.$store.getters.tasks
      }
      return this.filter === 'active'
    }
  }
}
</script>

<style lang="stylus" scoped>
//
// Header buttons list
//
.task-list__header
  display flex
  justify-content space-between
  align-items center
  margin-bottom 30px
.ui-title-1
  margin-bottom 0

//
// Task item
//
.task-item
  margin-bottom 20px
  .ui-checkbox:checked:before
    border-color #909399
  &.completed
    .ui-title-2,
    .ui-text-regular,
    .ui-tag
      // text-decoration line-through
      color #909399
  &:last-child
    margin-bottom 0

.ui-tag__wrapper
  margin-right 16px

// Info
.task-item__info
  display flex
  align-items center
  justify-content space-between
  margin-bottom 20px
  .button-close
    width 40px
    height @width
  .ui-label
    margin-right 8px

// Header
.task-item__header
  display flex
  align-items center
  margin-bottom 18px
  .ui-checkbox-wrapper
    margin-right 8px
  .ui-title-2
    margin-bottom 6px

// Body
.task-item__body
  margin-bottom 20px

// Footer
.tag-list
  margin-bottom 20px

.task-item__foter
  .buttons-list
    text-align right

// ALL buttons
.buttons-list
  .button
    margin-bottom 10px
    margin-right 12px
    &:last-child
      margin-right 0

// POPUP
.ui-messageBox__wrapper
  &.active
    display flex
  .button-light
    margin-right 8px

</style>



// WEBPACK FOOTER //
// src/components/Task.vue